import { h } from 'vue';
import { t } from '@/ui/i18n/i18n';
import { ChecklistCreateButton } from '@/ui/pages/checklist/ChecklistCreateButton';
import { emptyEntry } from '@/ui/pages/EmptyStateEntry';
import { hasPermission, Permissions } from '@/ui/auth/auth';

const checklistButton = (text: string) => h(ChecklistCreateButton, {
  class: 'empty-state-entry__button',
  props: {
    text,
    query: {
      fromRoute: 'inspectionCreateFromTemplate',
    },
  },
});

export const inspectionFromTemplateEmpty = () => h('div', { class: 'columns has-text-centered empty-state' }, [
  emptyEntry(
    '/images/inspection_from_template.svg',
    t('checklist.create-template'),
    t('inspections.start-from-tpl-info'),
    hasPermission(Permissions.MANAGE_CHECKLISTS) ? checklistButton(t('checklist.create-template')) : null,
  ),
]);
